import ReactDOM from "react-dom";
import React from "react";
import { App } from "./App";

const app = document.getElementById("app");
ReactDOM.render(<App />, app);
